<template>
  <header>
    <navbar-header />
  </header>
</template>

<script>
import NavbarHeader from './NavbarHeader.vue'
export default {
  components: { NavbarHeader },

}
</script>

<style>

</style>